<span class="badge rounded-pill {{ badgeClass }} fw-normal">
  @if (showDot) {
    <span class="badge-dot"></span>
  }
  {{ value }}
</span>
